import React, { useEffect, useState } from 'react';
import { DatePicker, Select } from 'antd';
import moment from 'moment';
import axios from 'axios';
import { Line } from '@ant-design/plots';
import client from '../../../../lib/feathers';
import styles from './index.module.scss';

const { RangePicker } = DatePicker;
const { Option } = Select;

const LineChart = ({
  deviceNameArr,
  deviceTable,
  deviceIndex,
  tableName,
  onDevice,
  onUnit,
}) => {
  const [DeviceName, setDeviceName] = useState([]);
  const [filter, setFilter] = useState({
    timeStart: moment().startOf('month').valueOf(),
    timeEnd: moment().add(1, 'd').endOf('month').valueOf(),
    unit: 'day',
    chartType: 'lineChart',
    tableName,
  });
  const [chartData, setChartData] = useState([]);

  useEffect(() => {
    if (deviceTable && deviceIndex) {
      const NameArr = [];
      deviceTable.map((item) => {
        const database = client.service(item);
        database
          .find({})
          .then((res) => {
            res.data.map((dataset) => NameArr.push(dataset[deviceIndex]));
            const filteredArray = NameArr.filter(function (ele, pos) {
              return NameArr.indexOf(ele) === pos;
            });
            setDeviceName(filteredArray);
          })
          .catch((error) => {
            console.log(error);
          });

        return true;
      });
    }
    if (deviceNameArr) {
      setDeviceName(deviceNameArr);
    }
  }, [deviceTable, deviceIndex, deviceNameArr]);

  useEffect(() => {
    let str = '';
    Object.keys(filter).forEach((key) => {
      str += `${key}=${filter[key]}&`;
    });
    console.log(str);
    axios(`/ezcon/api/efficacyStatisticChart?${str}`, {
      method: 'GET',
      headers: {
        authorization: window.localStorage['feathers-jwt'],
      },
    })
      .then((res) => {
        console.log(res);
        setChartData(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [filter]);
  const config = {
    data: chartData,
    isGroup: true,
    padding: 'auto',
    xField: 'Date',
    yField: 'scales',
    seriesField: 'name',
    xAxis: {
      tickCount: 5,
      title: {
        text: '日期',
        style: {
          fontSize: 12,
        },
      },
      label: {
        autoHide: true,
        autoRotate: false,
      },
    },
    yAxis: {
      title: {
        text: '次數(次）',
        style: {
          fontSize: 12,
        },
      },
    },
    legend: {
      position: 'top-right',
    },
    meta: {
      scales: {
        alias: '次數',
      },
    },
  };

  return (
    <>
      <div>
        <div className={styles.FilterTitle}>
          時間：
          {onUnit && (
            <Select
              value={filter.unit}
              onChange={(value) => {
                const newFilter = { ...filter };
                newFilter.unit = value;
                if (value !== 'hour') {
                  newFilter.timeStart = moment(newFilter.timeStart)
                    .startOf(value)
                    .valueOf();
                  newFilter.timeEnd = moment(newFilter.timeEnd)
                    .subtract(1, 'd')
                    .endOf(value)
                    .add(1, 'd')
                    .valueOf();
                } else {
                  newFilter.timeStart = moment(newFilter.timeStart)
                    .startOf(value)
                    .valueOf();
                  newFilter.timeEnd = moment(newFilter.timeStart)
                    .endOf(value)
                    .add(1, 'd')
                    .valueOf();
                }
                setFilter(newFilter);
              }}
            >
              <Option value="hour">小時</Option>
              <Option value="day">日</Option>
              <Option value="month">月</Option>
              <Option value="year">年</Option>
            </Select>
          )}
          {filter.unit === 'hour' ? (
            <DatePicker
              value={moment(filter.timeStart)}
              onChange={(value) => {
                const newFilter = { ...filter };
                newFilter.timeStart = moment(value).startOf('day').valueOf();
                newFilter.timeEnd = moment(value).endOf('day').valueOf();
                setFilter(newFilter);
              }}
            />
          ) : (
            <RangePicker
              picker={filter.unit}
              value={[
                moment(filter.timeStart),
                moment(filter.timeEnd).subtract(1, 'd'),
              ]}
              onChange={(value) => {
                const newFilter = { ...filter };
                newFilter.timeStart = moment(value[0]).valueOf();
                newFilter.timeEnd = moment(value[1]).add(1, 'd').valueOf();
                setFilter(newFilter);
              }}
            />
          )}
        </div>
        {onDevice && (
          <div className={styles.FilterTitle}>
            類型：
            <Select
              value={filter.deviceName}
              style={{ width: 120 }}
              showSearch
              placeholder="請選擇"
              onChange={(value) => {
                const newFilter = { ...filter };
                if (value !== '全部') {
                  newFilter.deviceName = value;
                } else {
                  delete newFilter.deviceName;
                  delete newFilter.deviceTitle;
                }
                setFilter(newFilter);
              }}
            >
              <Option value="">全部</Option>
              {DeviceName.map((x) => (
                <Option value={x}>{x}</Option>
              ))}
            </Select>
          </div>
        )}

        <div style={{ marginTop: 40 }}>
          <Line {...config} />
        </div>
      </div>
    </>
  );
};

export default LineChart;
